import type { CondimentSaleDTO } from '@six-pockets/shared';
import { PencilIcon, ReceiptIcon, TrashIcon } from '@/components/icons';
import { Button } from '@/components/ui';
import { cx } from '@/utils/cx';
import { formatClock, formatINR } from '@/utils/format';
import { itemsSummary } from '../utils';
import styles from '@/styles/components/SaleRow/style.scss';

interface SaleRowProps {
  sale: CondimentSaleDTO;
  /** Actions for open tabs; omitted for billed ones. Generate bill is omitted without the bills module. */
  onEdit?: () => void;
  onBill?: () => void;
  onDelete?: () => void;
}

/** One condiment tab on the Condiments page. Wraps onto several lines on narrow screens. */
export function SaleRow({ sale, onEdit, onBill, onDelete }: SaleRowProps) {
  const open = sale.status === 'open';

  return (
    <li className={cx(styles.row, !open && styles.billed)}>
      <div className={styles.main}>
        <div className={styles.titleRow}>
          <span className={styles.label}>{sale.tabName}</span>
          <span className={styles.meta}>{formatClock(sale.createdAt)}</span>
        </div>
        <span className={styles.items}>{itemsSummary(sale.items)}</span>
      </div>
      <span className={styles.money}>{formatINR(sale.total)}</span>
      {open && (
        <div className={styles.actions}>
          {onEdit && <Button size="sm" variant="ghost" iconOnly icon={<PencilIcon size={15} />} aria-label={`Edit ${sale.tabName}'s tab`} title="Edit" onClick={onEdit} />}
          {onDelete && <Button size="sm" variant="ghost" iconOnly icon={<TrashIcon size={15} />} aria-label={`Delete ${sale.tabName}'s tab`} title="Delete" onClick={onDelete} />}
          {onBill && (
            <Button size="sm" variant="primary" icon={<ReceiptIcon size={15} />} onClick={onBill}>
              Generate Bill
            </Button>
          )}
        </div>
      )}
    </li>
  );
}
